import { ListPanel } from "pages/components/ListPanel/";
import { ListWrapper } from "pages/components/ListWrapper/";
import { ContactResponse } from "../../types";
import { ItemCreateCard } from "pages/components/ItemCreateCard/";
import { useTranslate } from "#src/hooks";
import { AvatarPreviewCard } from "./AvatarPreviewCard";
import { Grid } from "antd";
import { UserIcon } from "@phosphor-icons/react";
import { useVoicePreviewPlayback } from "../../hooks/useVoicePreviewPlayback";

export const CARD_MAX_WIDTH = 372;

export const AvatarPanel = ({
  avatars,
  organizationId,
}: {
  avatars: ContactResponse[];
  organizationId?: string;
}) => {
  const t = useTranslate();
  const { getVoiceForCard, handleVoiceChange } = useVoicePreviewPlayback();
  const breakpoints = Grid.useBreakpoint();

  const textToFilterBy = (item: ContactResponse) =>
    item.firstname + " " + item.lastname;

  return (
    <ListWrapper>
      <ListPanel
        carouselProps={{
          empty: {
            image: <UserIcon size={100} />,
          },
          rows: breakpoints.xs ? 1 : 2,
          slidesToShow: breakpoints.xxl ? 4 : 3,
        }}
        items={avatars}
        getSearchText={textToFilterBy}
        title={t("pages.components.ListPanel.avatar", { count: 2 })}
        renderItems={(filteredAvatars: ContactResponse[]) => {
          return filteredAvatars?.map((item) => (
            <div key={item.id} style={{ maxWidth: CARD_MAX_WIDTH }}>
              <div
                style={{
                  margin: "20px 10px",
                  maxWidth:
                    filteredAvatars.length === 1 ? CARD_MAX_WIDTH : undefined,
                }}
              >
                <AvatarPreviewCard
                  contact={item}
                  organizationId={organizationId}
                  currentlyPlayingVoice={getVoiceForCard(item.id)}
                  setCurrentlyPlayingVoice={handleVoiceChange(item.id)}
                />
              </div>
            </div>
          ));
        }}
      />
      <ItemCreateCard
        itemName={t("pages.components.ListPanel.avatar", {
          count: 1,
        }).toLowerCase()}
        title={t("media.contacts.index.createCustomAvatar")}
        description={t("media.contacts.index.createAvatarDescription")}
      />
    </ListWrapper>
  );
};
